// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"3152":"21c8e16a","6603":"c07084b2","7523":"5d77173a"}[chunkId] + ".css";
};